import { Card, Space, Watermark } from "antd";
import { getTelegram } from "Api/TelegramApi/telegram";
import { MyTitle } from "Components/MyTitle/MyTitle";
import { defaultSettings } from "css/defaultAntStyles";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router";
import { DeleteOutlined } from "@ant-design/icons";
import MyBtnConfirm from "Components/MyBtnConfirm/MyBtnConfirm";
import { MyLoader } from "Components/MyLoader/MyLoader";
import {
  errorNotification,
  successNotification,
} from "Components/MyNotification";
import TelegramApi from "Api/TelegramApi/TelegramApi";
import { formatDate } from "Helpers/formatDate";
export const TelegramBlanksPage = () => {
  const params = useParams();
  const [isLoading, setIsLoading] = useState(true);
  const [isAllowed, setIsAllowed] = useState(false);
  const [projectBlanks, setProjectBlanks] = useState([]);
  const navigate = useNavigate();
  const getSavedBlanksForProject = async (projectId) => {
    try {
      setIsLoading(true);
      const result = await TelegramApi.getSavedBlanksForProject(projectId);
      if (result.status === "fail") {
        errorNotification(result.message);
        throw result?.message || "Помилка при отриманні бланків";
      }
      setProjectBlanks(result.dto);
    } catch (err) {
      errorNotification(err.message);
    } finally {
      setIsLoading(false);
    }
  };
  const handleDeleteBlank = async (elemId) => {
    try {
      setIsLoading(true);
      const result = await TelegramApi.deleteSavedBlankForProject(
        elemId,
        params.projectId,
      );
      if (result.status === "fail") {
        errorNotification(result.message);
        throw result?.message || "Помилка при видаленні бланку";
      }
      successNotification("Бланк видалено!");
      await getSavedBlanksForProject(params.projectId);
    } catch (err) {
      errorNotification(err.message);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    const tg = getTelegram();

    const isTelegram =
      tg && tg.initData && tg.initData.length > 0 && tg.platform !== "unknown";

    if (!isTelegram || !params.projectId) {
      setIsAllowed(false);
      return;
    }

    setIsAllowed(true);

    tg.ready();
    tg.expand();
    getSavedBlanksForProject(params.projectId);
  }, []);
  if (isAllowed === false) {
    return (
      <Watermark content="ПРОМАВТОМАТИКА" rotate={30} gap={[90, 90]}>
        <Card
          bodyStyle={{ padding: "30px 8px 10px 8px", height: "100vh" }}
        ></Card>
      </Watermark>
    );
  }
  if (isLoading) {
    return <MyLoader isFull />;
  }
  return (
    <Card bodyStyle={{ padding: "25px 8px 10px 8px", minHeight: "100vh" }}>
      {projectBlanks.length ? (
        <>
          <MyTitle text={"Мої збережені бланки по проекту"} level={5} />
          <Space direction="vertical" size={12} style={{ width: "100%" }}>
            {projectBlanks.map((elem) => {
              return (
                <Card
                  onClick={() =>
                    navigate(
                      `/telegram/blank/${params.projectId}?blankId=${elem.id}`,
                    )
                  }
                >
                  <div
                    style={{
                      display: "flex",
                      gap: "5px",
                      justifyContent: "space-between",
                      flexWrap: "wrap",
                      fontSize: "18px",
                    }}
                  >
                    <p>Бланк від {formatDate(elem.createdAt)}</p>
                    <div
                      style={{
                        display: "flex",
                        gap: "15px",
                      }}
                      onClick={(e) => e.stopPropagation()}
                    >
                      <MyBtnConfirm
                        btnIcon={
                          <DeleteOutlined
                            style={{ color: defaultSettings.colorPrimary }}
                          />
                        }
                        icon={
                          <DeleteOutlined
                            style={{ color: defaultSettings.colorPrimary }}
                          />
                        }
                        ghost={true}
                        fontSize="20px"
                        type=""
                        mainTitle={`Видалити бланк за ${formatDate(elem.createdAt)}?`}
                        onConfirm={() => {
                          handleDeleteBlank(elem.id);
                        }}
                      />
                    </div>
                  </div>
                </Card>
              );
            })}
          </Space>
        </>
      ) : (
        <MyTitle
          text={"Немає збережених бланків по проекту"}
          level={5}
          textAlign="center"
        />
      )}
    </Card>
  );
};
